var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-normal-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.66683 14.5002C11.1646 14.5002 14.0002 11.6646 14.0002 8.16683C14.0002 4.66902 11.1646 1.8335 7.66683 1.8335C4.16902 1.8335 1.3335 4.66902 1.3335 8.16683C1.3335 11.6646 4.16902 14.5002 7.66683 14.5002Z",
    fill: "#213A51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.2002 15.1659C14.0802 15.1659 13.9602 15.1192 13.8735 15.0326L12.6335 13.7926C12.4535 13.6126 12.4535 13.3192 12.6335 13.1326C12.8135 12.9526 13.1069 12.9526 13.2935 13.1326L14.5335 14.3726C14.7135 14.5526 14.7135 14.8459 14.5335 15.0326C14.4402 15.1192 14.3202 15.1659 14.2002 15.1659Z",
    fill: "#213A51"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchInput);
export default __webpack_public_path__ + "static/media/search-input.35b3cf030d14237cb3550c933ec9388f.svg";
export { ForwardRef as ReactComponent };